export const scannerParams = (state, getters) => {
    return state.params || {};
}
